<template>

<div id="ethics" class="document">

  <Title :text="$t('ethics.title')"/>

  <Common :text="$t('ethics.paragraph01')"/>

  <Common :text="$t('ethics.paragraph02')"/>

  <div>

    <Ul
      section="ethics"
      :items="[
        $t('ethics.bullets.bullet01'),
        $t('ethics.bullets.bullet02'),
        $t('ethics.bullets.bullet03'),
        $t('ethics.bullets.bullet04'),
        $t('ethics.bullets.bullet05')
      ]"/>

  </div>

  <Common :text="$t('ethics.paragraph03')"/>

</div>

</template>

<script>
import Title from './general/texts/Title.vue'
import Common from './general/texts/Common.vue'
import Ul from './general/elements/Ul.vue'

export default {
  name: 'Ethics',
  components: {
    Title,
    Common,
    Ul
  }
}
</script>

<style lang="scss" scoped>
ul {
  list-style: initial;
  padding-left: 40px;
}
</style>
